import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AddOn, AddOnOption } from '../../../../model';
import { take, tap } from 'rxjs/operators';
import { compareStringsIgnoreCase, emitValueIfValid, ignoreNullish, Loadable, LoadableStatus } from '@aiwyn/shared';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AdditionalServiceComponent } from '../additional-service/additional-service.component';

@Component({
  selector: 'app-add-add-on',
  templateUrl: './add-add-on.component.html',
  styleUrls: ['./add-add-on.component.scss'],
  standalone: false,
})
export class AddAddOnComponent {
  addOnOptions$ = new BehaviorSubject<Loadable<AddOnOption[]>>(undefined);
  @Input() set addOnOptions(addOnOptions: Loadable<AddOnOption[]>) {
    emitValueIfValid(addOnOptions, this.addOnOptions$);
  }

  @Output() added = new EventEmitter<AddOn>();

  LoadableStatus = LoadableStatus;

  constructor(private readonly dialog: MatDialog) {}

  /**
   * Open dialog to create add-on.
   * @param addOnOptions types of add-ons to choose from
   */
  openAdditionalServiceDialog(addOnOptions: AddOnOption[]): void {
    const otherPaymentType = addOnOptions.find(({ type }) => type === 'MISCELLANEOUS');
    if (otherPaymentType != undefined) {
      addOnOptions = addOnOptions
        .filter(({ type }) => type !== 'MISCELLANEOUS')
        .sort((a, b) => compareStringsIgnoreCase(a.type, b.type))
        .concat(otherPaymentType);
    }

    this.dialog.open(AdditionalServiceComponent, { data: { addOnOptions } }).afterClosed().pipe(
      take(1),
      ignoreNullish(),
      tap(addOn => this.added.emit(addOn)),
    ).subscribe();
  }
}
